import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    height: '100%',
    [theme.breakpoints.down('sm')]: {
      overflowX: 'hidden'
    },
  },
  toolbar: {
    display: 'flex',
    alignItems: 'center',
    boxShadow: '0px 1px 0px #E5E5E5',
    boxSizing: 'border-box',
    marginBottom: '5px',
    minHeight: '48px',
  },
  toolbarLeft: {
    display: 'flex',
    alignItems: 'center',
    minWidth: '140px',
    height: '100%',
    borderRight: '1px solid #E2EBF6',
    boxSizing: 'border-box',
    color: '#59758B',
    [theme.breakpoints.down('sm')]: {
      minWidth: '100px',
    },
  },
  toolbarTitle: {
    padding: '12px 30px',
    fontWeight: 'bold',
    fontSize: '18px',
    lineHeight: '24px',
    color: '#000000',
    [theme.breakpoints.down('sm')]: {
      padding: '8px 16px',
      fontSize: '16px',
    },
  },
  customTabRoot: {
    color: '#335267',
    padding: '0px 30px',
    borderBottom: '1px solid #E2EBF6',
    boxSizing: 'border-box',
    fontSize: '13px',
    minWidth: '84px!important',
  },
  tabsRoot: {
    flex: '1 1 auto',
    backgroundColor: theme.palette.background.paper,
    display: 'flex',
  },
  tabs: {
    flex: '0 1 220px',
    [theme.breakpoints.down('sm')]: {
      flex: '0 1 150px',
    },
  },
  customTabWrapper: {
    alignItems: 'flex-start',
  },
  horizontalTabs: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    padding: '32px 30px',
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      padding: '16px',
    },
  },
  tabContentWrapper: {
    padding: '0px 30px',
    [theme.breakpoints.down('sm')]: {
      padding: '0px 16px',
    },
  },
  accommodationOverviewTab: {
    width: '230px',
    height: '175px',
    border: '1px solid #E2EBF6',
    borderRadius: '3px',
    padding: '12px 20px',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      marginBottom: '26px',
      height: '100%'
     
    },
  },
  activityOverviewTab: {
    width: '290px',
    height: '175px',
    border: '1px solid #E2EBF6',
    borderRadius: '3px',
    padding: '12px 20px',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      marginBottom: '26px',
      height: '100%'
    },
  },
  numberTitle: {
    width: '228px',
    height: '42px',
    fontSize: '37px',
    fontWeight: 'bold',
    color: '#0E8BB4',
  },
  tabDescription: {
    paddingTop: '10px',
  },
  seeMoreOption: {
    paddingTop: '30px',
    color: '#59758B',
    width: '56px',
    '&:hover': {
      cursor: 'pointer',
    },
  },
  tableTitle: {
    fontSize: '15px',
    fontWeight: 'bold',
    paddingRight: '15px',
    borderRight: '1px solid #E2EBF6',
    marginRight: '10px',
  },
  viewSwitchers: {
    display: 'flex',
    '&:hover': {
      cursor: 'pointer',
    },
    marginBottom: '18px',
    alignItems: 'center',
  },
  calendarIcon: {
    paddingLeft: '15px',
    paddingRight: '10px',
    fill: '#59758B',
  },
  calendarTitle: {
    color: '#59758B',
  },
  backToolbar: {
    paddingLeft: '30px',
    display: 'flex',
    alignItems: 'center',
    [theme.breakpoints.down('sm')]: {
      paddingLeft: '16px',
    },
  },
  backIcon: {
    paddingRight: '10px',
    fill: '#59758B',
  },
  button: {
    padding: 0,
    height: '20px',
    '&:hover': {
      backgroundColor: '#fff',
    },
  },
  selected: {
    backgroundColor: '#E2F5F8',
    fontWeight: 'bold',
  },
  textColorInheritCustom: {
    opacity: 1,
    color: '#335267',
  },
  backButtonText: {
    color: '#59758B',
    paddingLeft: '6px',
    paddingRight: '15px',
    borderRight: '1px solid #E2EBF6',
  },
}));

export default useStyles;
